import { axios } from '@Root/API'

export const create = data => {
	return axios.post('create/student-course-session', data)
}
